import {makeStyles} from "@material-ui/core";

export default function DevolucoesListaCss() {
    return makeStyles(theme => ({
        root: {
            marginTop: 20
        },
    }));
}